import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=a98d300a&scoped=true"
import script from "./Mailing.vue?vue&type=script&lang=js"
export * from "./Mailing.vue?vue&type=script&lang=js"
import style0 from "./Mailing.vue?vue&type=style&index=0&id=a98d300a&prod&lang=stylus&scoped=true"
import style1 from "./Mailing.vue?vue&type=style&index=1&id=a98d300a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98d300a",
  null
  
)

export default component.exports